const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_DAY = SECONDS_PER_HOUR * 24;

export const FormatElapsedTime = (seconds: number): string => {
  if (!seconds) {
    return 'No Activity';
  }

  if (seconds < SECONDS_PER_MINUTE) {
    return `${Math.floor(seconds)} seconds`;
  }
  if (seconds < SECONDS_PER_HOUR) {
    return `${Math.floor(seconds / SECONDS_PER_MINUTE)} minutes`;
  }
  if (seconds < SECONDS_PER_DAY) {
    const hoursOnly = Math.floor(seconds / SECONDS_PER_HOUR);
    const minutesOnly = Math.floor((seconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
    return `${hoursOnly} hours, ${minutesOnly} minutes`;
  }

  const days = Math.floor(seconds / SECONDS_PER_DAY);
  const hours = Math.floor((seconds % SECONDS_PER_DAY) / SECONDS_PER_HOUR);
  return `${days} days, ${hours} hours`;
};
